var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.formItem.deliveryType === "express"
        ? _c(
            "el-form-item",
            { attrs: { label: "快递公司：", prop: "expressCode" } },
            [
              _c(
                "el-select",
                {
                  style: _vm.isShowBtn ? "width: 83%" : "width:100%",
                  attrs: { filterable: "" },
                  model: {
                    value: _vm.formItem.expressCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.formItem, "expressCode", $$v)
                    },
                    expression: "formItem.expressCode",
                  },
                },
                _vm._l(_vm.express, function (item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { value: item.code, label: item.name },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowBtn,
                      expression: "isShowBtn",
                    },
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["merchant:express:relate"],
                      expression: "['merchant:express:relate']",
                    },
                  ],
                  staticClass: "ml24",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleCreat },
                },
                [_vm._v("设置物流公司")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "express"
        ? _c(
            "el-form-item",
            { attrs: { label: "快递单号：", prop: "expressNumber" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入快递单号" },
                model: {
                  value: _vm.formItem.expressNumber,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "expressNumber",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.expressNumber",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "noNeed"
        ? _c(
            "el-form-item",
            { attrs: { label: "发货备注：" } },
            [
              _c("el-input", {
                attrs: {
                  "show-word-limit": "",
                  autosize: { minRows: 4 },
                  maxlength: "250",
                  type: "textarea",
                  placeholder: "请输入备注信息，最多可输入250字",
                },
                model: {
                  value: _vm.formItem.deliveryMark,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "deliveryMark",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.deliveryMark",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "merchant"
        ? _c(
            "el-form-item",
            { attrs: { label: "配送人员：", prop: "deliveryCarrier" } },
            [
              _c(
                "div",
                { staticClass: "acea-row" },
                [
                  _c(
                    "el-select",
                    {
                      style: _vm.isShowBtn ? "width: 85%" : "width:100%",
                      attrs: {
                        "value-key": "id",
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.handleChangePersonnel },
                      model: {
                        value: _vm.selectedValue,
                        callback: function ($$v) {
                          _vm.selectedValue = $$v
                        },
                        expression: "selectedValue",
                      },
                    },
                    _vm._l(_vm.personnelList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.personnelName, value: item },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowBtn,
                          expression: "isShowBtn",
                        },
                      ],
                      staticClass: "ml24",
                      on: {
                        click: function ($event) {
                          return _vm.handleCreatPersonnel()
                        },
                      },
                    },
                    [_vm._v("添加配送员")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.formItem.deliveryType === "merchant"
        ? _c(
            "el-form-item",
            { attrs: { label: "手机号码：", prop: "carrierPhone" } },
            [
              _c("el-input", {
                attrs: { disabled: "", placeholder: "请输入配送人员手机号码" },
                model: {
                  value: _vm.formItem.carrierPhone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formItem,
                      "carrierPhone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formItem.carrierPhone",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("creat-express", {
        ref: "craetExpressRef",
        on: { handlerSuccessSubmit: _vm.getList },
      }),
      _c("creat-personnel", {
        attrs: { dialogVisible: _vm.dialogVisible, editData: _vm.editData },
        on: {
          handlerCloseFrom: _vm.handlerCloseFrom,
          handlerSuccessSubmit: _vm.handlerSuccessSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }